const STORAGE_KEY = "takeoff-ai-history-session";
let sessionPromise: Promise<string> | undefined;

/** Keep a lineage across reloads while giving a duplicated tab its own lease. */
export function getAiHistorySession(): Promise<string> {
  if (sessionPromise) return sessionPromise;
  sessionPromise = new Promise((resolve) => {
    const fresh = () => crypto.randomUUID();
    const locks = navigator.locks;
    if (!locks) {
      // Without a lease we cannot distinguish a reload from a cloned tab.
      resolve(fresh());
      return;
    }
    let stored: string | null = null;
    try { stored = sessionStorage.getItem(STORAGE_KEY); } catch { /* Storage may be disabled. */ }
    const acquire = (candidate: string) => {
      void locks.request(`takeoff-ai-history:${candidate}`, { ifAvailable: true }, async (lock) => {
        if (!lock) {
          acquire(fresh());
          return;
        }
        try { sessionStorage.setItem(STORAGE_KEY, candidate); } catch { /* A fresh lineage is still safe. */ }
        resolve(candidate);
        // The browser releases this lease when the document closes or reloads.
        await new Promise<void>(() => {});
      }).catch(() => resolve(fresh()));
    };
    acquire(stored ?? fresh());
  });
  return sessionPromise;
}
